import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger alert-dismissible fade show m-3",
  role: "alert"
}
const _hoisted_2 = {
  key: 0,
  class: "fw-bold mb-1"
}
const _hoisted_3 = {
  class: "mb-0",
  style: {"white-space":"pre-line"}
}
const _hoisted_4 = {
  key: 1,
  class: "alert alert-success alert-dismissible fade show m-3",
  role: "alert"
}
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = {
  key: 2,
  class: "clearfix"
}
const _hoisted_7 = {
  key: 3,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_8 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "row g-3 align-items-center" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2" }
const _hoisted_12 = {
  key: 0,
  class: "text-end"
}
const _hoisted_13 = {
  key: 0,
  class: "alert alert-danger py-2 px-3 mb-2"
}
const _hoisted_14 = { class: "col-12 col-lg-8" }
const _hoisted_15 = { class: "row g-2" }
const _hoisted_16 = { class: "col-12 col-sm-6 col-lg-3" }
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "col-12 col-sm-6 col-lg-3"
}
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "col-12 col-sm-6 col-lg-3" }
const _hoisted_21 = { class: "col-12 col-sm-6 col-lg-3" }
const _hoisted_22 = { class: "col-12 col-lg-4" }
const _hoisted_23 = { class: "d-flex flex-wrap gap-2 justify-content-lg-end" }
const _hoisted_24 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_25 = { class: "text-muted" }
const _hoisted_26 = {
  key: 0,
  class: "badge bg-success"
}
const _hoisted_27 = {
  key: 1,
  class: "badge bg-danger"
}
const _hoisted_28 = { class: "table-responsive" }
const _hoisted_29 = { class: "table table-hover align-middle mb-0" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "ps-0" }
const _hoisted_32 = { class: "d-flex align-items-center" }
const _hoisted_33 = {
  key: 0,
  class: "badge bg-danger ms-1",
  title: "Erreurs"
}
const _hoisted_34 = { class: "badge bg-light text-dark" }
const _hoisted_35 = { class: "text-end" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 1,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_38 = { class: "d-flex flex-wrap gap-3 align-items-center" }
const _hoisted_39 = { class: "text-paragraph" }
const _hoisted_40 = { class: "fw-bold" }
const _hoisted_41 = { class: "text-paragraph" }
const _hoisted_42 = {
  key: 0,
  class: "text-paragraph"
}
const _hoisted_43 = { class: "text-danger fw-bold" }
const _hoisted_44 = { class: "pagination mb-0" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "d-flex flex-wrap gap-2 justify-content-end mt-3" }
const _hoisted_47 = {
  key: 0,
  class: "w-100 mb-2"
}
const _hoisted_48 = { class: "alert alert-warning alert-sm py-2 px-3 mb-0" }
const _hoisted_49 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_50 = {
  key: 1,
  class: "fw-bold"
}
const _hoisted_51 = ["disabled", "title"]
const _hoisted_52 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status"
}
const _hoisted_53 = {
  key: 1,
  class: "flaticon-send me-1"
}
const _hoisted_54 = {
  class: "modal fade",
  id: "importModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_55 = { class: "modal-dialog modal-xl modal-dialog-centered" }
const _hoisted_56 = { class: "modal-content" }
const _hoisted_57 = { class: "modal-body" }
const _hoisted_58 = { class: "row g-2 mb-3" }
const _hoisted_59 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_60 = { class: "col-md-6" }
const _hoisted_61 = { class: "table-responsive" }
const _hoisted_62 = { class: "table table-hover align-middle mb-0" }
const _hoisted_63 = { class: "table-light" }
const _hoisted_64 = { class: "ps-0" }
const _hoisted_65 = ["checked"]
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { class: "ps-0" }
const _hoisted_68 = ["value", "onChange"]
const _hoisted_69 = ["id", "onChange"]
const _hoisted_70 = ["value"]
const _hoisted_71 = { class: "text-end" }
const _hoisted_72 = ["id", "onInput"]
const _hoisted_73 = { class: "modal-footer" }
const _hoisted_74 = ["disabled"]
const _hoisted_75 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_76 = {
  key: 1,
  class: "flaticon-import me-1"
}
const _hoisted_77 = {
  class: "modal fade",
  id: "notificationModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_78 = { class: "modal-dialog modal-xl modal-dialog-centered" }
const _hoisted_79 = { class: "modal-content" }
const _hoisted_80 = { class: "modal-body" }
const _hoisted_81 = { class: "row g-3 mb-3" }
const _hoisted_82 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_83 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_84 = { class: "table table-hover align-middle mb-0" }
const _hoisted_85 = ["value", "id", "onInput"]
const _hoisted_86 = ["id", "onChange"]
const _hoisted_87 = ["value", "selected"]
const _hoisted_88 = { class: "text-end" }
const _hoisted_89 = ["value", "id", "onInput"]
const _hoisted_90 = {
  key: 0,
  class: "modal-footer"
}

import { ref, onMounted, reactive, inject, computed } from "vue";
import axios from 'axios';
import router from '../../../router/index';
import { read, utils } from 'xlsx';
import { Modal } from 'bootstrap';
import { current_permissions } from '../../../utils/permission';
import { showToast, checkSessionValidate, strUUID } from '../../../utils/function';
import { Business, Contact, Operator } from "@/utils/Model";


export default /*@__PURE__*/_defineComponent({
  __name: 'MassTransfertsContent',
  setup(__props) {

const backApi = inject('back');

const token = localStorage.getItem('login_token');
const organizationCode = localStorage.getItem('organization_code');
const role = localStorage.getItem('role');
const isSuperAdmin = computed(() => role === 'SUPERADMIN');

// Infos nécessaires à la vérification du solde (comme sur la page transactions)
const usercode = localStorage.getItem('code');
const account_size = parseFloat(localStorage.getItem('account_size') + '');
const personnal_account_status = localStorage.getItem('personnal_account_status');

const loader = ref(true);
const isLoading = ref(false);
const isImporting = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(10);

const business = ref<Business[]>([]);
const subBusiness = ref<Business[]>([]);
const businessTemp = ref<Business[]>([]);
const operators = ref<Operator[]>([]);
const operatorsTemp = ref<Operator[]>([]);
const contacts = ref<Contact[]>([]);
const filteredContacts = ref<Contact[]>([]);
const transferts = ref<any[]>([]);

// Solde
const payoutBalance = ref(0);
let balance = 0;

// Filtres
const selectedBusiness = ref('');
const selectedSubBusiness = ref('');
const selectedCountry = ref('');
const selectedCountryContact = ref('');
const transferDate = ref('');
const searchContact = ref('');
const showSubBusiness = ref(false);

// Upload de fichier
const fileInput = ref<HTMLInputElement | null>(null);
const fileName = ref('');
const isDragging = ref(false);

const selectedContacts = ref<string[]>([]);
const allSelected = ref(false);
const contactSelections = reactive<Record<string, { operator: string; amount: number }>>({});
const contactData = reactive<Record<string, Contact>>({});

// Validation
const validationErrors = ref<any[]>([]);
const validationStats = reactive({
  amount: { count: 0, label: 'Erreurs de montant' },
  telSize: { count: 0, label: 'Numéros invalides' },
  telFormat: { count: 0, label: 'Format de téléphone' },
  telOperator: { count: 0, label: 'Opérateur inconnu' },
  duplicateTel: { count: 0, label: 'Doublons' },
});

// États UI
const errors = ref('');
const errorId = ref('');
const success = ref('');
const totalTransfertAmount = ref(0);

const EXPECTED_HEADERS = ['NOM', 'PRENOM', 'PHONE_NUMBER', 'AMOUNT', 'PAYMENT_METHOD'];

const PHONE_LENGTH_BY_COUNTRY: Record<string, number> = {
  CI: 10,
  SN: 9,
};

const COUNTRY_DIAL_CODES: Record<string, string> = {
  CI: '225',
  SN: '221',
};

function getPhoneLength(country: string): number {
  return PHONE_LENGTH_BY_COUNTRY[country] || 10;
}

function normalizePhoneNumber(rawMobile: any, country: string): string {
  let mobile = String(rawMobile ?? '').replace(/\s|-/g, '').trim();

  const hasPlus = mobile.startsWith('+');
  mobile = mobile.replace(/\D/g, '');

  if (!hasPlus && mobile.startsWith('00')) {
    mobile = mobile.substring(2);
  }

  const dialCode = COUNTRY_DIAL_CODES[country];
  const expectedLength = getPhoneLength(country);

  if (dialCode && mobile.startsWith(dialCode)) {
    const withoutCode = mobile.substring(dialCode.length);
    if (withoutCode.length === expectedLength) {
      mobile = withoutCode;
    }
  }

  return mobile;
}

// Computed
const totalBeneficiaries = computed(() => transferts.value.length);
const totalPages = computed(() => Math.ceil(transferts.value.length / itemsPerPage.value) || 1);

const displayedPages = computed(() => {
  const pages = [];
  const total = totalPages.value;
  const current = currentPage.value;

  if (total <= 7) {
    for (let i = 1; i <= total; i++) pages.push(i);
  } else {
    if (current <= 3) {
      pages.push(1, 2, 3, '...', total);
    } else if (current >= total - 2) {
      pages.push(1, '...', total - 2, total - 1, total);
    } else {
      pages.push(1, '...', current - 1, current, current + 1, '...', total);
    }
  }
  return pages;
});

const paginatedTransferts = computed(() => {
  const list = transferts.value || [];
  const start = (currentPage.value - 1) * itemsPerPage.value;
  const end = Math.min(start + itemsPerPage.value, list.length);
  return list.slice(start, end);
});

// Le transfert est bloqué si : pas de bénéficiaires, pas de pays, erreurs de validation,
// chargement en cours, OU montant total > solde disponible.
const canTransfer = computed(() => {
  const hasBeneficiaries = transferts.value.length > 0;
  const hasCountry = selectedCountry.value !== '' && selectedCountry.value !== null;
  const noErrors = validationErrors.value.length === 0;
  const notLoading = !isLoading.value;
  // const hasSufficientBalance = totalTransfertAmount.value > 0 && totalTransfertAmount.value <= payoutBalance.value;

  return hasBeneficiaries && hasCountry && noErrors && notLoading;
});

const availableOperators = computed(() => operators.value);

// Méthodes
function formatNumber(value: number): string {
  return new Intl.NumberFormat('fr-FR').format(value || 0);
}

function showToastMessage(message: string, type: 'success' | 'error' | 'info' = 'success') {
  showToast(message, type);
}

function refreshPage() {
  router.go();
}

function changePage(page: number) {
  if (page < 1 || page > totalPages.value) return;
  currentPage.value = page;
}

function getTransferButtonTitle(): string {
  if (transferts.value.length === 0) return 'Aucun bénéficiaire à transférer';
  if (!selectedCountry.value) return 'Veuillez sélectionner un pays';
  if (validationErrors.value.length > 0) return 'Corrigez les erreurs avant de transférer';
  if (isLoading.value) return 'Transfert en cours...';
  return 'Transférer l\'argent aux bénéficiaires';
}

//  SOLDE 

/**
 * Récupère le solde du compte "personnel" (payout perso), utilisé quand
 * le compte a un account_size > 0 et est ACTIVE — même logique que la page Transactions.
 */
function getTransfertBalancePerso() {
  return axios.post(`${backApi}/secure/accounts/balance/main`, {
    user: usercode,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      payoutBalance.value = response.data.balance;
      balance = response.data.balance;
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          // router.push('/')
        }
      }
    });
}

/**
 * Récupère le solde de l'organisation (compte payout classique).
 */
function getBalancePayout() {
  return axios.post(`${backApi}/secure/accounts/balance/main`, {
    organization: organizationCode,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      payoutBalance.value = response.data.balance;
      balance = response.data.balance;
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        }
      }
    });
}

function loadBalance() {
  if (account_size > 0 && personnal_account_status === "ACTIVE") {
    return getTransfertBalancePerso();
  }
  return getBalancePayout();
}

//  UPLOAD DE FICHIER 

function triggerFileUpload() {
  if (!selectedCountry.value) {
    showToastMessage('Veuillez d\'abord sélectionner un pays', 'error');
    return;
  }
  if (fileInput.value) {
    fileInput.value.click();
  }
}

function handleDrop(event: DragEvent) {
  isDragging.value = false;
  if (!selectedCountry.value) {
    showToastMessage('Veuillez d\'abord sélectionner un pays', 'error');
    return;
  }
  const files = event.dataTransfer?.files;
  if (files && files.length > 0) {
    const file = files[0];
    processFile(file);
  }
}

function handleFileUpload(event: Event) {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];
  if (file) {
    processFile(file);
  }
  input.value = '';
}

function processFile(file: File) {
  // Vérifier le type de fichier
  const validTypes = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'text/csv'
  ];

  if (!validTypes.includes(file.type) && !file.name.match(/\.(xlsx|xls|csv)$/i)) {
    setFormatError(
      'Format de fichier non supporté',
      `Le fichier "${file.name}" n'est pas un fichier Excel/CSV valide. Utilisez un fichier au format .xlsx, .xls ou .csv, idéalement le modèle fourni via le bouton "Télécharger modèle".`
    );
    return;
  }

  // Vérifier la taille (max 5MB)
  if (file.size > 5 * 1024 * 1024) {
    setFormatError(
      'Fichier trop volumineux',
      'Le fichier dépasse la taille maximale autorisée de 5 Mo. Réduisez le nombre de lignes ou scindez le fichier en plusieurs imports.'
    );
    return;
  }

  fileName.value = file.name;
  showToastMessage(`Lecture du fichier: ${file.name}`, 'info');

  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      const workbook = read(data, { type: 'array' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = utils.sheet_to_json(worksheet, { header: 1 });

      processExcelData(jsonData);

    } catch (error) {
      console.error('Erreur lors de la lecture du fichier:', error);
      setFormatError(
        'Fichier illisible',
        'Le fichier n\'a pas pu être lu. Assurez-vous qu\'il n\'est pas corrompu et qu\'il correspond bien au modèle fourni.'
      );
    }
  };
  reader.readAsArrayBuffer(file);
}

function setFormatError(title: string, detail: string) {
  errorId.value = title;
  errors.value = detail;
  showToastMessage(title, 'error');
}

function processExcelData(jsonData: any[]) {
  // Vérifier que le fichier contient des données
  if (!jsonData || jsonData.length < 2) {
    setFormatError(
      'Fichier vide',
      'Le fichier importé ne contient aucune ligne de bénéficiaire. Téléchargez le modèle et remplissez-le avant de l\'importer.'
    );
    return;
  }

  const headers = (jsonData[0] || []).map((h: any) => (h ?? '').toString().trim().toUpperCase());
  const missing = EXPECTED_HEADERS.filter((h, i) => headers[i] !== h);

  if (missing.length > 0) {
    setFormatError(
      'Format de fichier invalide',
      `Les colonnes du fichier ne correspondent pas au modèle attendu.\n` +
      `Colonnes attendues (dans cet ordre) : ${EXPECTED_HEADERS.join(', ')}.\n` +
      `Colonnes trouvées : ${headers.filter(Boolean).join(', ') || 'aucune'}.\n` +
      `Veuillez télécharger le modèle via "Télécharger modèle" et l'utiliser sans modifier l'ordre ou le nom des colonnes.`
    );
    return;
  }

  const phoneLength = getPhoneLength(selectedCountry.value);

  // Traiter les lignes
  const importedData: any[] = [];
  const seenMobiles = new Set<string>();
  let totalAmount = 0;
  let skippedIncomplete = 0;

  for (let i = 1; i < jsonData.length; i++) {
    const row = jsonData[i];
    if (!row || row.every((cell: any) => cell === undefined || cell === '')) continue; // ligne vide

    if (!row[0] || row[2] === undefined || row[2] === '' || row[3] === undefined || row[3] === '') {
      skippedIncomplete++;
      continue;
    }

    //  Nettoyage + retrait de l'indicatif pays éventuel
    const mobile = normalizePhoneNumber(row[2], selectedCountry.value);
    const amount = parseFloat(row[3]);

    const beneficiary = {
      clientId: `${row[0]} ${row[1] || ''}`.trim(),
      mobile,
      amount: isNaN(amount) ? 0 : amount,
      operator: (row[4] || '').toString().trim(),
      countryCode: selectedCountry.value,
      code: strUUID(),
      errors: [] as string[]
    };

    if (isNaN(beneficiary.amount) || beneficiary.amount <= 0) {
      beneficiary.errors.push('Montant invalide (doit être supérieur à 0)');
    }

    if (!/^\d+$/.test(beneficiary.mobile)) {
      beneficiary.errors.push('Format de téléphone invalide (chiffres uniquement)');
    } else if (beneficiary.mobile.length !== phoneLength) {
      beneficiary.errors.push(`Le numéro doit contenir ${phoneLength} chiffres (${selectedCountry.value === 'CI' ? 'Côte d\'Ivoire' : selectedCountry.value === 'SN' ? 'Sénégal' : 'pays sélectionné'})`);
    }

    if (seenMobiles.has(beneficiary.mobile)) {
      beneficiary.errors.push('Doublon détecté (numéro déjà présent dans le fichier)');
    } else {
      seenMobiles.add(beneficiary.mobile);
    }

    importedData.push(beneficiary);
    totalAmount += beneficiary.amount > 0 ? beneficiary.amount : 0;
  }

  if (importedData.length === 0) {
    setFormatError(
      'Aucune donnée valide',
      'Aucune ligne exploitable n\'a été trouvée dans le fichier. Vérifiez que le nom, le téléphone et le montant sont bien renseignés pour chaque bénéficiaire.'
    );
    return;
  }

  transferts.value = importedData;
  totalTransfertAmount.value = totalAmount;
  currentPage.value = 1;

  validateBeneficiaries(transferts.value);

  const skippedMsg = skippedIncomplete > 0 ? ` (${skippedIncomplete} ligne(s) incomplète(s) ignorée(s))` : '';

  if (validationErrors.value.length > 0) {
    showToastMessage(`${validationErrors.value.length} ligne(s) contiennent des erreurs${skippedMsg}`, 'error');
    const modalEl = document.getElementById('notificationModal');
    if (modalEl) {
      const modal = Modal.getOrCreateInstance(modalEl);
      modal.show();
    }
  } else if (totalAmount > payoutBalance.value) {
    showToastMessage(`Solde insuffisant : le montant total (${formatNumber(totalAmount)} XOF) dépasse votre solde disponible (${formatNumber(payoutBalance.value)} XOF)${skippedMsg}`, 'error');
  } else {
    showToastMessage(`${importedData.length} bénéficiaire(s) importé(s) avec succès${skippedMsg}`, 'success');
  }
}

function downloadTemplate() {
  window.open('/model_payout.xls', '_blank');
}


function getOperators() {
  return new Promise((resolve, reject) => {
    axios.get(`${backApi}/secure/operators/available/${process.env.VUE_APP_PAYOUT_OPTTYPE}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(response => {
      operatorsTemp.value = response.data;
      operators.value = response.data;
      resolve(response);
    })
    .catch(error => {
      if (error.response?.status === 401) router.push('/');
      reject(error);
    });
  });
}


function getBusiness() {
  return new Promise((resolve, reject) => {
    const endpoint = isSuperAdmin.value
      ? `${backApi}/secure/business/extended/`
      : `${backApi}/secure/business/?organization=${organizationCode}`;

    axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(response => {
      businessTemp.value = response.data;
      business.value = businessTemp.value.filter(item => item.parent === null);
      resolve(response);
    })
    .catch(error => {
      if (error.response?.status === 401) {
        router.push('/');
      }
      reject(error);
    });
  });
}


function getContacts() {
  const endpoint = isSuperAdmin.value
    ? `${backApi}/secure/contactbooks/extended/`
    : `${backApi}/secure/contactbook/?organization=${organizationCode}`;

  axios.get(endpoint, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then(response => {
    contacts.value = response.data || [];
    filteredContacts.value = response.data || [];
  })
  .catch(error => {
    if (error.response?.status === 401) {
      router.push('/');
    }
  });
}

function filterContacts() {
  const query = searchContact.value.toLowerCase().trim();
  if (!query) {
    filteredContacts.value = contacts.value;
  } else {
    filteredContacts.value = contacts.value.filter(c =>
      (c.first_name?.toLowerCase().includes(query) || '') ||
      (c.last_name?.toLowerCase().includes(query) || '') ||
      (c.contact?.includes(query) || '')
    );
  }
}

//  VALIDATION 

function validateBeneficiaries(data: any[]) {
  validationErrors.value = [];

  const phoneLength = getPhoneLength(selectedCountry.value);

  const mobileCounts: Record<string, number> = {};
  data.forEach(item => {
    const key = normalizePhoneNumber(item.mobile, selectedCountry.value);
    mobileCounts[key] = (mobileCounts[key] || 0) + 1;
  });

  data.forEach(item => {
    const itemErrors: string[] = [];

    const phone = normalizePhoneNumber(item.mobile, selectedCountry.value);
    item.mobile = phone;

    if (item.amount === undefined || item.amount === null || isNaN(item.amount) || item.amount <= 0) {
      itemErrors.push('Montant invalide (doit être supérieur à 0)');
    }

    if (!/^\d+$/.test(phone)) {
      itemErrors.push('Format de téléphone invalide (chiffres uniquement)');
    } else if (phone.length !== phoneLength) {
      itemErrors.push(`Téléphone doit faire ${phoneLength} chiffres`);
    }

    if (item.operator) {
      const opExists = operators.value.some(o => o.mnoName === item.operator);
      if (!opExists) {
        itemErrors.push('Opérateur inconnu');
      }
    }

    if (mobileCounts[phone] > 1) {
      itemErrors.push('Doublon détecté');
    }

    if (itemErrors.length > 0) {
      item.errors = itemErrors;
      validationErrors.value.push(item);
    } else {
      item.errors = [];
    }
  });

  validationStats.amount.count = validationErrors.value.filter(e => e.errors.some((err: string) => err.startsWith('Montant invalide'))).length;
  validationStats.telSize.count = validationErrors.value.filter(e => e.errors.some((err: string) => err.includes('doit faire'))).length;
  validationStats.telFormat.count = validationErrors.value.filter(e => e.errors.some((err: string) => err.includes('Format de téléphone invalide'))).length;
  validationStats.telOperator.count = validationErrors.value.filter(e => e.errors.includes('Opérateur inconnu')).length;
  validationStats.duplicateTel.count = validationErrors.value.filter(e => e.errors.includes('Doublon détecté')).length;
}


function onErrorFieldChange(event: Event, item: any, field: string) {
  const rawValue = (event.target as HTMLInputElement).value;

  if (field === 'amount') {
    item.amount = parseFloat(rawValue) || 0;
  } else if (field === 'mobile') {
    item.mobile = normalizePhoneNumber(rawValue, item.countryCode || selectedCountry.value);
  } else {
    item[field] = rawValue;
  }

  const index = transferts.value.findIndex(t => t.code === item.code);
  if (index !== -1) {
    transferts.value[index][field] = item[field];
  }

  validateBeneficiaries(transferts.value);
  totalTransfertAmount.value = transferts.value.reduce((sum, t) => sum + (t.amount > 0 ? t.amount : 0), 0);
}

function onErrorOperatorChange(event: Event, item: any) {
  item.operator = (event.target as HTMLSelectElement).value;
  const index = transferts.value.findIndex(t => t.code === item.code);
  if (index !== -1) {
    transferts.value[index].operator = item.operator;
  }
  validateBeneficiaries(transferts.value);
}

function applyCorrections() {
  validateBeneficiaries(transferts.value);
  if (validationErrors.value.length === 0) {
    const modalEl = document.getElementById('notificationModal');
    if (modalEl) {
      const modal = Modal.getOrCreateInstance(modalEl);
      modal.hide();
    }
    showToastMessage('Toutes les erreurs ont été corrigées', 'success');
  } else {
    showToastMessage(`Il reste ${validationErrors.value.length} erreur(s) à corriger`, 'error');
  }
}


function openImportModal() {
  if (!selectedCountry.value) {
    showToastMessage('Veuillez d\'abord sélectionner un pays', 'error');
    return;
  }
  getContacts();
  selectedContacts.value = [];
  allSelected.value = false;
  const modalEl = document.getElementById('importModal');
  if (modalEl) {
    const modal = Modal.getOrCreateInstance(modalEl);
    modal.show();
  }
}

function closeImportModal() {
  selectedContacts.value = [];
  allSelected.value = false;
}

function onContactSelect(contact: Contact) {
  if (!contactData[contact.code]) {
    contactData[contact.code] = contact;
  }
}

function onOperatorChange(event: Event, contact: Contact) {
  const value = (event.target as HTMLSelectElement).value;
  if (!contactSelections[contact.code]) {
    contactSelections[contact.code] = { operator: '', amount: 0 };
  }
  contactSelections[contact.code].operator = value;
}

function onAmountChange(event: Event, contact: Contact) {
  const value = parseFloat((event.target as HTMLInputElement).value) || 0;
  if (!contactSelections[contact.code]) {
    contactSelections[contact.code] = { operator: '', amount: 0 };
  }
  contactSelections[contact.code].amount = value;
}

function selectAllContacts() {
  allSelected.value = !allSelected.value;
  if (allSelected.value) {
    selectedContacts.value = filteredContacts.value.map(c => c.code);
    filteredContacts.value.forEach(c => contactData[c.code] = c);
  } else {
    selectedContacts.value = [];
  }
}

function importSelectedContacts() {
  if (selectedContacts.value.length === 0) return;

  isImporting.value = true;
  const imported: any[] = [];
  const targetCountry = selectedCountryContact.value || selectedCountry.value;
  const phoneLength = getPhoneLength(targetCountry);
  let rejected = 0;

  selectedContacts.value.forEach(code => {
    const contact = contactData[code] || contacts.value.find(c => c.code === code);
    if (contact) {
      const selection = contactSelections[code] || { operator: '', amount: 0 };

      if (!selection.operator || !(selection.amount > 0)) {
        rejected++;
        return;
      }

      const mobile = normalizePhoneNumber(contact.contact, targetCountry);

      const alreadyExists = transferts.value.some(t => t.mobile === mobile) ||
        imported.some(t => t.mobile === mobile);

      if (alreadyExists) {
        rejected++;
        return;
      }

      imported.push({
        clientId: `${contact.first_name} ${contact.last_name}`.trim(),
        mobile,
        amount: selection.amount,
        operator: selection.operator,
        countryCode: targetCountry,
        code: strUUID(),
        errors: mobile.length === phoneLength ? [] : [`Le numéro doit contenir ${phoneLength} chiffres`]
      });
    }
  });

  if (imported.length > 0) {
    transferts.value = [...transferts.value, ...imported];

    validateBeneficiaries(transferts.value);
    totalTransfertAmount.value = transferts.value.reduce((sum, t) => sum + (t.amount > 0 ? t.amount : 0), 0);

    const rejectedMsg = rejected > 0 ? ` (${rejected} contact(s) ignoré(s) : doublon, montant ou opérateur manquant)` : '';

    if (validationErrors.value.length === 0) {
      const modalEl = document.getElementById('importModal');
      if (modalEl) {
        const modal = Modal.getOrCreateInstance(modalEl);
        modal.hide();
      }
      if (totalTransfertAmount.value > payoutBalance.value) {
        showToastMessage(`${imported.length} contacts importés, mais le solde est insuffisant pour ce montant${rejectedMsg}`, 'error');
      } else {
        showToastMessage(`${imported.length} contacts importés avec succès${rejectedMsg}`, 'success');
      }
    } else {
      showToastMessage(`${imported.length} contacts importés, ${validationErrors.value.length} à corriger${rejectedMsg}`, 'error');
      const modalEl = document.getElementById('notificationModal');
      if (modalEl) {
        const modal = Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    }
  } else {
    showToastMessage('Aucun contact valide sélectionné (opérateur, montant > 0, ou doublon détecté)', 'error');
  }

  isImporting.value = false;
  selectedContacts.value = [];
  allSelected.value = false;
}


function handleBusinessChange() {
  showSubBusiness.value = false;
  if (selectedBusiness.value) {
    const parent = businessTemp.value.find(b => b.code === selectedBusiness.value);
    if (parent?.validatePayoutBeforProcess) {
      showToastMessage('Cette catégorie nécessite une validation', 'info');
    }
    subBusiness.value = businessTemp.value.filter(b => b.parent?.code === selectedBusiness.value);
    showSubBusiness.value = subBusiness.value.length > 0;
  }
}

function handleSubBusinessChange() {
  if (selectedSubBusiness.value) {
    const item = businessTemp.value.find(b => b.code === selectedSubBusiness.value);
    if (item?.validatePayoutBeforProcess) {
      showToastMessage('Cette catégorie nécessite une validation', 'info');
    }
  }
}

function handleCountryChange() {
  if (selectedCountry.value) {
    operators.value = operatorsTemp.value.filter(o => o.countryCode === selectedCountry.value);
  } else {
    operators.value = operatorsTemp.value;
  }

  if (transferts.value.length > 0) {
    transferts.value.forEach(t => {
      t.mobile = normalizePhoneNumber(t.mobile, selectedCountry.value);
      t.countryCode = selectedCountry.value;
    });
    validateBeneficiaries(transferts.value);
    showToastMessage(`Numéros revalidés pour ${getPhoneLength(selectedCountry.value)} chiffres`, 'info');
  }

  if (fileInput.value) {
    fileInput.value.value = '';
  }
  fileName.value = '';
}

function handleCountryChangeContact() {
  if (selectedCountryContact.value) {
    operators.value = operatorsTemp.value.filter(o => o.countryCode === selectedCountryContact.value);
  } else {
    operators.value = operatorsTemp.value;
  }
}

function resetBeneficiaries() {
  transferts.value = [];
  totalTransfertAmount.value = 0;
  validationErrors.value = [];
  Object.keys(validationStats).forEach(key => validationStats[key as keyof typeof validationStats].count = 0);
}

function removeBeneficiary(index: number) {
  const realIndex = (currentPage.value - 1) * itemsPerPage.value + index;
  if (realIndex >= 0 && realIndex < transferts.value.length) {
    const removed = transferts.value[realIndex];
    transferts.value.splice(realIndex, 1);
    totalTransfertAmount.value -= removed.amount || 0;
    validateBeneficiaries(transferts.value);
    if (transferts.value.length === 0) {
      currentPage.value = 1;
    }
  }
}


/**
 * Envoie les transferts vers le backend.
 * Vérifications appliquées avant l'appel API (dans l'ordre) :
 *  1. Il doit y avoir au moins un bénéficiaire.
 *  2. Un pays doit être sélectionné.
 *  3. Aucune erreur de validation ne doit subsister sur la liste.
 *  4. Le montant total à transférer ne doit pas dépasser le solde disponible (payoutBalance).
 */
function sendMoney() {
  if (!canTransfer.value) {
    let message = 'Veuillez vérifier les éléments suivants:\n';
    if (transferts.value.length === 0) message += '- Aucun bénéficiaire\n';
    if (!selectedCountry.value) message += '- Pays non sélectionné\n';
    if (validationErrors.value.length > 0) message += '- Des erreurs doivent être corrigées\n';
    if (totalTransfertAmount.value > payoutBalance.value) {
      message += `- Solde insuffisant : montant total ${formatNumber(totalTransfertAmount.value)} XOF > solde disponible ${formatNumber(payoutBalance.value)} XOF\n`;
    }
    showToastMessage(message, 'error');
    return;
  }

  // Double vérification explicite du solde juste avant l'appel réseau
  // (protège contre un montant modifié après le calcul de canTransfer).
  if (totalTransfertAmount.value > payoutBalance.value) {
    errorId.value = 'Solde insuffisant';
    errors.value = `Le montant total à transférer (${formatNumber(totalTransfertAmount.value)} XOF) dépasse votre solde disponible (${formatNumber(payoutBalance.value)} XOF).`;
    showToastMessage(errors.value, 'error');
    return;
  }

  isLoading.value = true;
  const transactionData = transferts.value.map(t => ({
    clientId: t.clientId,
    mobile: t.mobile,
    amount: t.amount,
    operator: t.operator,
    countryCode: selectedCountry.value
  }));

  const payload = {
    payoutType: 2,
    operationType: parseInt(process.env.VUE_APP_PAYOUT_OPTTYPE || '1'),
    scheduledAt: transferDate.value || null,
    business: selectedBusiness.value || null,
    transactions: transactionData
  };

  axios.post(`${backApi}/secure/transactions/init`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    isLoading.value = false;
    showToastMessage('Transfert effectué avec succès', 'success');
    setTimeout(() => refreshPage(), 2000);
  })
  .catch(error => {
    isLoading.value = false;
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/');
      } else {
        errors.value = error.response.data.message || 'Erreur lors du transfert';
        errorId.value = error.response.data.errorId || '';
        showToastMessage(errors.value, 'error');
      }
    }
  });
}


onMounted(async () => {
  checkSessionValidate(1);
  loader.value = false;

  try {
    await Promise.all([
      getOperators(),
      getBusiness(),
      loadBalance()
    ]);
    loader.value = true;
  } catch (error) {
    console.error('Erreur lors du chargement:', error);
    loader.value = true;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (errors.value !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (errorId.value !== '')
            ? (_openBlock(), _createElementBlock("h6", _hoisted_2, _toDisplayString(errorId.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_3, _toDisplayString(errors.value), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (errors.value = ''))
          })
        ]))
      : _createCommentVNode("", true),
    (success.value !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(success.value), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (success.value = ''))
          })
        ]))
      : _createCommentVNode("", true),
    (!loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[14] || (_cache[14] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1),
          _createElementVNode("div", {
            class: "text-center",
            style: {"margin-top":"-5vh"}
          }, [
            _createElementVNode("p", { class: "text-muted" }, "Chargement en cours...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-muted fs-13 text-uppercase fw-semibold" }, "Solde disponible", -1)),
                    _createElementVNode("h5", {
                      class: _normalizeClass(["mb-0 fw-bold", totalTransfertAmount.value > payoutBalance.value ? 'text-danger' : 'text-success'])
                    }, _toDisplayString(formatNumber(payoutBalance.value)) + " XOF ", 3)
                  ]),
                  (transferts.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-muted fs-13 text-uppercase fw-semibold" }, "Montant à transférer", -1)),
                        _createElementVNode("h5", {
                          class: _normalizeClass(["mb-0 fw-bold", totalTransfertAmount.value > payoutBalance.value ? 'text-danger' : 'text-dark'])
                        }, _toDisplayString(formatNumber(totalTransfertAmount.value)) + " XOF ", 3)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (transferts.value.length > 0 && totalTransfertAmount.value > payoutBalance.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[17] || (_cache[17] = [
                      _createElementVNode("i", { class: "flaticon-alert me-1" }, null, -1),
                      _createTextVNode(" Solde insuffisant pour effectuer ce transfert ", -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-sm shadow-none",
                      onChange: handleBusinessChange,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedBusiness).value = $event))
                    }, [
                      _cache[18] || (_cache[18] = _createElementVNode("option", { value: "" }, "Sélectionnez une catégorie", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(business.value, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.code,
                          value: item.code
                        }, _toDisplayString(item.name), 9, _hoisted_17))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, selectedBusiness.value]
                    ])
                  ]),
                  (showSubBusiness.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select form-select-sm shadow-none",
                          onChange: handleSubBusinessChange,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedSubBusiness).value = $event))
                        }, [
                          _cache[19] || (_cache[19] = _createElementVNode("option", { value: "" }, "Sélectionnez une sous-catégorie", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subBusiness.value, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item.code,
                              value: item.code
                            }, _toDisplayString(item.name), 9, _hoisted_19))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, selectedSubBusiness.value]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-sm shadow-none",
                      onChange: handleCountryChange,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedCountry).value = $event))
                    }, [...(_cache[20] || (_cache[20] = [
                      _createElementVNode("option", { value: "" }, "Sélectionnez le pays", -1),
                      _createElementVNode("option", { value: "SN" }, "Sénégal (9 chiffres)", -1),
                      _createElementVNode("option", { value: "CI" }, "Côte d'Ivoire (10 chiffres)", -1)
                    ]))], 544), [
                      [_vModelSelect, selectedCountry.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((transferDate).value = $event)),
                      type: "date",
                      class: "form-control form-control-sm shadow-none",
                      placeholder: "Date de transfert"
                    }, null, 512), [
                      [_vModelText, transferDate.value]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-primary",
                    onClick: triggerFileUpload
                  }, [...(_cache[21] || (_cache[21] = [
                    _createElementVNode("i", { class: "flaticon-upload me-1" }, null, -1),
                    _createTextVNode(" Importer fichier ", -1)
                  ]))]),
                  _createElementVNode("input", {
                    type: "file",
                    id: "fileUpload",
                    ref_key: "fileInput",
                    ref: fileInput,
                    accept: ".xlsx,.xls,.csv",
                    style: {"display":"none"},
                    onChange: handleFileUpload
                  }, null, 544),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-secondary",
                    onClick: downloadTemplate
                  }, [...(_cache[22] || (_cache[22] = [
                    _createElementVNode("i", { class: "flaticon-file-1 me-1" }, null, -1),
                    _createTextVNode(" Télécharger modèle ", -1)
                  ]))]),
                  _createElementVNode("button", {
                    class: "btn btn-sm text-white",
                    style: {"background-color":"#EB9355"},
                    onClick: openImportModal
                  }, [...(_cache[23] || (_cache[23] = [
                    _createElementVNode("i", { class: "flaticon-plus me-1" }, null, -1),
                    _createTextVNode(" Importer contacts ", -1)
                  ]))])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            (transferts.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["drop-zone p-4 text-center border-2 border-dashed rounded-3 mb-3", { 'border-primary bg-primary bg-opacity-10': isDragging.value }]),
                  onDragover: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (isDragging.value = true), ["prevent"])),
                  onDragenter: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (isDragging.value = true), ["prevent"])),
                  onDragleave: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (isDragging.value = false), ["prevent"])),
                  onDrop: _withModifiers(handleDrop, ["prevent"])
                }, [
                  _cache[24] || (_cache[24] = _createElementVNode("i", { class: "flaticon-upload fs-1 text-muted d-block mb-2" }, null, -1)),
                  _createElementVNode("p", _hoisted_25, _toDisplayString(fileName.value || 'Glissez-déposez votre fichier Excel ici ou cliquez sur "Importer fichier"'), 1),
                  _cache[25] || (_cache[25] = _createElementVNode("p", { class: "text-muted small" }, " Formats acceptés: .xlsx, .xls, .csv ", -1)),
                  (selectedCountry.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, " Pays: " + _toDisplayString(selectedCountry.value) + " (" + _toDisplayString(getPhoneLength(selectedCountry.value)) + " chiffres) ", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_27, " Veuillez sélectionner un pays "))
                ], 34))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("table", _hoisted_29, [
                _cache[29] || (_cache[29] = _createElementVNode("thead", { class: "table-light" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      scope: "col",
                      class: "fw-medium text-uppercase fs-13 ps-0"
                    }, " NOM & PRÉNOM(S) "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "fw-medium text-uppercase fs-13"
                    }, " TÉLÉPHONE "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "fw-medium text-uppercase fs-13 text-end"
                    }, " MONTANT "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "fw-medium text-uppercase fs-13"
                    }, " OPÉRATEUR "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "fw-medium text-uppercase fs-13 text-end"
                    }, " ACTIONS ")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (transferts.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [...(_cache[26] || (_cache[26] = [
                        _createElementVNode("td", {
                          colspan: "5",
                          class: "text-center text-muted py-30"
                        }, [
                          _createElementVNode("i", { class: "flaticon-info fs-2 d-block mb-2" }),
                          _createTextVNode(" Aucun bénéficiaire importé ")
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedTransferts.value, (transfert, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: transfert.code || index
                    }, [
                      _createElementVNode("td", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _cache[27] || (_cache[27] = _createElementVNode("input", {
                            class: "form-check-input me-2",
                            type: "checkbox"
                          }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(transfert.clientId), 1)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass({ 'text-danger': transfert.errors && transfert.errors.length > 0 })
                        }, _toDisplayString(transfert.mobile), 3),
                        (transfert.errors && transfert.errors.length > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(transfert.errors.length), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", {
                        class: _normalizeClass(["text-end fw-semibold", { 'text-danger': transfert.errors && transfert.errors.length > 0 }])
                      }, _toDisplayString(formatNumber(transfert.amount)), 3),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_34, _toDisplayString(transfert.operator || 'Non défini'), 1)
                      ]),
                      _createElementVNode("td", _hoisted_35, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-danger",
                          onClick: ($event: any) => (removeBeneficiary(index))
                        }, [...(_cache[28] || (_cache[28] = [
                          _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
                        ]))], 8, _hoisted_36)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (transferts.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("span", _hoisted_39, [
                      _cache[30] || (_cache[30] = _createElementVNode("i", { class: "flaticon-users me-1" }, null, -1)),
                      _cache[31] || (_cache[31] = _createTextVNode(" Total bénéficiaires: ", -1)),
                      _createElementVNode("span", _hoisted_40, _toDisplayString(totalBeneficiaries.value), 1)
                    ]),
                    _createElementVNode("span", _hoisted_41, [
                      _cache[32] || (_cache[32] = _createElementVNode("i", { class: "flaticon-money me-1" }, null, -1)),
                      _cache[33] || (_cache[33] = _createTextVNode(" Montant total: ", -1)),
                      _createElementVNode("span", {
                        class: _normalizeClass(["fw-bold", totalTransfertAmount.value > payoutBalance.value ? 'text-danger' : 'text-success'])
                      }, _toDisplayString(formatNumber(totalTransfertAmount.value)), 3),
                      _cache[34] || (_cache[34] = _createTextVNode(" XOF ", -1))
                    ]),
                    (validationErrors.value.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                          _cache[35] || (_cache[35] = _createElementVNode("i", { class: "flaticon-alert me-1 text-danger" }, null, -1)),
                          _createElementVNode("span", _hoisted_43, _toDisplayString(validationErrors.value.length), 1),
                          _cache[36] || (_cache[36] = _createTextVNode(" erreur(s) à corriger ", -1))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("nav", null, [
                    _createElementVNode("ul", _hoisted_44, [
                      _createElementVNode("li", {
                        class: _normalizeClass(['page-item', { disabled: currentPage.value === 1 }])
                      }, [
                        _createElementVNode("a", {
                          class: "page-link",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (changePage(currentPage.value - 1)))
                        }, [...(_cache[37] || (_cache[37] = [
                          _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                        ]))])
                      ], 2),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedPages.value, (page) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: page,
                          class: _normalizeClass(['page-item', { active: page === currentPage.value }])
                        }, [
                          _createElementVNode("a", {
                            class: "page-link",
                            onClick: ($event: any) => (changePage(page))
                          }, _toDisplayString(page), 9, _hoisted_45)
                        ], 2))
                      }), 128)),
                      _createElementVNode("li", {
                        class: _normalizeClass(['page-item', { disabled: currentPage.value === totalPages.value }])
                      }, [
                        _createElementVNode("a", {
                          class: "page-link",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (changePage(currentPage.value + 1)))
                        }, [...(_cache[38] || (_cache[38] = [
                          _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                        ]))])
                      ], 2)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_46, [
              (!canTransfer.value && transferts.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _cache[39] || (_cache[39] = _createElementVNode("i", { class: "flaticon-alert me-1" }, null, -1)),
                      (!selectedCountry.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Veuillez sélectionner un pays"))
                        : (validationErrors.value.length > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(validationErrors.value.length) + " erreur(s) à corriger avant le transfert ", 1))
                          : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-outline-secondary btn-sm",
                onClick: refreshPage
              }, [...(_cache[40] || (_cache[40] = [
                _createElementVNode("i", { class: "flaticon-refresh me-1" }, null, -1),
                _createTextVNode(" Rafraîchir ", -1)
              ]))]),
              _createElementVNode("button", {
                class: "btn btn-sm text-white",
                style: {"background-color":"#EB9355"},
                disabled: !canTransfer.value || isLoading.value,
                onClick: sendMoney,
                title: getTransferButtonTitle()
              }, [
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_52))
                  : (_openBlock(), _createElementBlock("i", _hoisted_53)),
                _cache[41] || (_cache[41] = _createTextVNode(" Transferer l'argent ", -1))
              ], 8, _hoisted_51)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_54, [
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", { class: "modal-header" }, [
            _cache[42] || (_cache[42] = _createElementVNode("h5", { class: "modal-title" }, "Importation des contacts client", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              onClick: closeImportModal
            })
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              (isSuperAdmin.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _cache[44] || (_cache[44] = _createElementVNode("label", { class: "fw-semibold" }, "Pays", -1)),
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-sm shadow-none",
                      onChange: handleCountryChangeContact,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((selectedCountryContact).value = $event))
                    }, [...(_cache[43] || (_cache[43] = [
                      _createElementVNode("option", { value: "" }, "Sélectionnez...", -1),
                      _createElementVNode("option", { value: "SN" }, "Sénégal", -1),
                      _createElementVNode("option", { value: "CI" }, "Côte d'Ivoire", -1)
                    ]))], 544), [
                      [_vModelSelect, selectedCountryContact.value]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_60, [
                _cache[45] || (_cache[45] = _createElementVNode("label", { class: "fw-semibold" }, "Rechercher", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm shadow-none",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((searchContact).value = $event)),
                  onInput: filterContacts,
                  placeholder: "Rechercher un contact..."
                }, null, 544), [
                  [_vModelText, searchContact.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("table", _hoisted_62, [
                _createElementVNode("thead", _hoisted_63, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_64, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        onChange: selectAllContacts,
                        checked: allSelected.value
                      }, null, 40, _hoisted_65)
                    ]),
                    _cache[46] || (_cache[46] = _createElementVNode("th", null, "Nom complet", -1)),
                    _cache[47] || (_cache[47] = _createElementVNode("th", null, "Numéro de téléphone", -1)),
                    _cache[48] || (_cache[48] = _createElementVNode("th", null, "Opérateur", -1)),
                    _cache[49] || (_cache[49] = _createElementVNode("th", { class: "text-end" }, "Montant", -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (filteredContacts.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_66, [...(_cache[50] || (_cache[50] = [
                        _createElementVNode("td", {
                          colspan: "5",
                          class: "text-center text-muted py-30"
                        }, " Aucun contact trouvé ", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredContacts.value, (contact) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: contact.code
                    }, [
                      _createElementVNode("td", _hoisted_67, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          value: contact.code,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((selectedContacts).value = $event)),
                          onChange: ($event: any) => (onContactSelect(contact))
                        }, null, 40, _hoisted_68), [
                          [_vModelCheckbox, selectedContacts.value]
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(contact.first_name) + " " + _toDisplayString(contact.last_name), 1),
                      _createElementVNode("td", null, _toDisplayString(contact.contact), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("select", {
                          class: "form-select form-select-sm shadow-none",
                          id: contact.code + ':operator',
                          onChange: ($event: any) => (onOperatorChange($event, contact))
                        }, [
                          _cache[51] || (_cache[51] = _createElementVNode("option", { value: "" }, "Sélectionnez...", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableOperators.value, (op) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: op.code,
                              value: op.mnoName
                            }, _toDisplayString(op.mnoName), 9, _hoisted_70))
                          }), 128))
                        ], 40, _hoisted_69)
                      ]),
                      _createElementVNode("td", _hoisted_71, [
                        _createElementVNode("input", {
                          type: "number",
                          class: "form-control form-control-sm shadow-none text-end",
                          id: contact.code + ':amount',
                          min: "1",
                          onInput: ($event: any) => (onAmountChange($event, contact)),
                          placeholder: "Montant"
                        }, null, 40, _hoisted_72)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_73, [
            _cache[52] || (_cache[52] = _createElementVNode("button", {
              class: "btn btn-outline-secondary",
              "data-bs-dismiss": "modal"
            }, " Fermer ", -1)),
            _createElementVNode("button", {
              class: "btn text-white",
              style: {"background-color":"#EB9355"},
              disabled: selectedContacts.value.length === 0 || isImporting.value,
              onClick: importSelectedContacts
            }, [
              (isImporting.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_75))
                : (_openBlock(), _createElementBlock("i", _hoisted_76)),
              _createTextVNode(" Importer (" + _toDisplayString(selectedContacts.value.length) + ") ", 1)
            ], 8, _hoisted_74)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_77, [
      _createElementVNode("div", _hoisted_78, [
        _createElementVNode("div", _hoisted_79, [
          _cache[56] || (_cache[56] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Rapport de validation"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("div", _hoisted_81, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationStats, (stat, key) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-md-6 col-lg-4",
                  key: key
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["p-3 rounded", stat.count === 0 ? 'bg-success bg-opacity-10' : 'bg-danger bg-opacity-10'])
                  }, [
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("span", null, _toDisplayString(stat.label), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["fw-bold", stat.count === 0 ? 'text-success' : 'text-danger'])
                      }, _toDisplayString(stat.count), 3)
                    ])
                  ], 2)
                ]))
              }), 128))
            ]),
            (validationErrors.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                  _createElementVNode("table", _hoisted_84, [
                    _cache[54] || (_cache[54] = _createElementVNode("thead", { class: "table-light" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Nom complet"),
                        _createElementVNode("th", null, "Téléphone"),
                        _createElementVNode("th", null, "Opérateur"),
                        _createElementVNode("th", { class: "text-end" }, "Montant"),
                        _createElementVNode("th", null, "Erreurs")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (error) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: error.code
                        }, [
                          _createElementVNode("td", null, _toDisplayString(error.clientId), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control-sm shadow-none",
                              value: error.mobile,
                              id: error.code + ':mobile',
                              onInput: ($event: any) => (onErrorFieldChange($event, error, 'mobile'))
                            }, null, 40, _hoisted_85)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("select", {
                              class: "form-select form-select-sm shadow-none",
                              id: error.code + ':operator',
                              onChange: ($event: any) => (onErrorOperatorChange($event, error))
                            }, [
                              _cache[53] || (_cache[53] = _createElementVNode("option", { value: "" }, "Sélectionnez...", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableOperators.value, (op) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: op.code,
                                  value: op.mnoName,
                                  selected: op.mnoName === error.operator
                                }, _toDisplayString(op.mnoName), 9, _hoisted_87))
                              }), 128))
                            ], 40, _hoisted_86)
                          ]),
                          _createElementVNode("td", _hoisted_88, [
                            _createElementVNode("input", {
                              type: "number",
                              class: "form-control form-control-sm shadow-none text-end",
                              value: error.amount,
                              id: error.code + ':amount',
                              min: "1",
                              onInput: ($event: any) => (onErrorFieldChange($event, error, 'amount'))
                            }, null, 40, _hoisted_89)
                          ]),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(error.errors, (err) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: err,
                                class: "badge bg-danger me-1"
                              }, _toDisplayString(err), 1))
                            }), 128))
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (validationErrors.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                _createElementVNode("button", {
                  class: "btn text-white",
                  style: {"background-color":"#EB9355"},
                  onClick: applyCorrections
                }, [...(_cache[55] || (_cache[55] = [
                  _createElementVNode("i", { class: "flaticon-check me-1" }, null, -1),
                  _createTextVNode(" Appliquer les corrections ", -1)
                ]))])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _cache[57] || (_cache[57] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})